import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, int32_type, record_type, tuple_type, unit_type, bool_type, lambda_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { IsoCountryCode$reflection } from "../../DomainTypes.js";
import { Locale_get_FromSelectedLanguage, logei, logwi, classNames, DateTimeExtensions_toDateHHmm, Locale$reflection } from "../../Utils.js";
import { getCreateOrderDTO, resetParameters, toActionMap, ParameterType, Action, Parameter, Action$reflection } from "./Model.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ModalSize, getModalContainer, modal, getModalBodyContainer, getModalFooterContainer, getCustomModalHeader } from "../../Components/Modal/Modal.js";
import { cancel, main, ButtonProps, defaultProps, modalMain } from "../../Components/Button/Button.js";
import { tryFind, add, empty, toList } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { isEmpty, ofArray, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { singleton, delay, toList as toList_1 } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { correctPhoneNumber } from "../../Validation/Telecom.js";
import { DateOptions, DateOptions_get_getDefault, inputDate, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { OnChange as OnChange_2, Locale, FormatDateBy, Value, TimeTwentyFour, EnableTimePicker } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { stringHash, partialApply, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { loadOperationStatusesThunk } from "../../Api/Telecom.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { createOrder as createOrder_1, loadAvailableOperations as loadAvailableOperations_1 } from "./Api.js";
import { error } from "../../Components/Message/Message.js";
import { dotsLoading } from "../../ViewUtils.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import "../../../src/Containers/TelecomOrder/View.scss";


class ActionModalProps extends Record {
    constructor(GetTranslation, CountryCode, Locale, Action, IsAdd, CloseModalFn, CreateOrderFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.CountryCode = CountryCode;
        this.Locale = Locale;
        this.Action = Action;
        this.IsAdd = IsAdd;
        this.CloseModalFn = CloseModalFn;
        this.CreateOrderFn = CreateOrderFn;
    }
}

function ActionModalProps$reflection() {
    return record_type("Containers.TelecomOrder.View.ActionModalProps", [], ActionModalProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["CountryCode", IsoCountryCode$reflection()], ["Locale", Locale$reflection()], ["Action", Action$reflection()], ["IsAdd", bool_type], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["CreateOrderFn", lambda_type(tuple_type(Action$reflection(), bool_type), unit_type)]]);
}

const renderActionModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children_2, children_9, children_7, list, f2, action, inputRecord_3, LabelText_3;
    const actionState = react.useState(props.Action);
    let modalHeader;
    const translation = props.IsAdd ? props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Order.Add") : props.GetTranslation("Common.Remove");
    const arg_1 = (actionState[0]).Name;
    modalHeader = toText(printf("%s: %s"))(translation)(arg_1);
    const headerHtml = getCustomModalHeader((children_4 = [react.createElement("h1", {
        className: "modal-base__heading",
    }, modalHeader), (children_2 = [(actionState[0]).Description], react.createElement("p", {
        className: "blockquote-footer text-center",
    }, ...children_2))], react.createElement(react.Fragment, {}, ...children_4)), (_arg) => {
        props.CloseModalFn();
    });
    const footerHtml = getModalFooterContainer(modalMain(new ButtonProps(props.GetTranslation("Common.Continue"), defaultProps.Content, (_arg_1) => {
        props.CreateOrderFn([actionState[0], props.IsAdd]);
    }, defaultProps.Disabled, "action-modal-continue-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)));
    const bodyHtml = getModalBodyContainer((children_9 = [(children_7 = ((list = toList(defaultArg(props.IsAdd ? (actionState[0]).AddParameters : (actionState[0]).RemoveParameters, empty())), map((f2 = ((action = (actionState[0]), (parameter) => {
        const dispatchAction = (parameterType) => {
            let value_1;
            if (props.IsAdd) {
                const updatedParams = add(parameter.Name, new Parameter(parameter.Name, parameter.Index, parameterType), action.AddParameters);
                actionState[1]((x) => (new Action(x.Name, x.Description, x.Category, x.Date, updatedParams, x.RemoveParameters)));
            }
            else {
                const updatedParams_1 = map_1((value_1 = (new Parameter(parameter.Name, parameter.Index, parameterType)), (table_1) => add(parameter.Name, value_1, table_1)), action.RemoveParameters);
                actionState[1]((x_1) => (new Action(x_1.Name, x_1.Description, x_1.Category, x_1.Date, x_1.AddParameters, updatedParams_1)));
            }
        };
        const children_5 = toList_1(delay(() => {
            let inputRecord_1, inputRecord_2, inputRecord;
            const matchValue = parameter.Type;
            switch (matchValue.tag) {
                case 1: {
                    return singleton(render_1()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(matchValue.fields[0], inputRecord_1.Type, inputRecord_1.Classes, (e) => {
                        dispatchAction(new ParameterType(1, Browser_Types_Event__Event_get_Value(e)));
                    }, inputRecord_1.Disabled, parameter.Name, parameter.Name, inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, (_arg_3) => {
                        const matchValue_1 = [action.Name.toLocaleLowerCase(), parameter.Name.toLocaleLowerCase(), parameter.Type];
                        let pattern_matching_result;
                        if (matchValue_1[0] === "activate") {
                            if (matchValue_1[1] === "number") {
                                if (matchValue_1[2].tag === 1) {
                                    pattern_matching_result = 0;
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                        switch (pattern_matching_result) {
                            case 0: {
                                dispatchAction(new ParameterType(1, correctPhoneNumber(props.CountryCode, matchValue_1[2].fields[0])));
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    }, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))));
                }
                case 2: {
                    const options = matchValue.fields[1];
                    return singleton(selectOption((inputRecord_2 = SelectOption_get_getDefault(), new SelectOption(new ValueProp(0, matchValue.fields[0], (e_1) => {
                        let tupledArg;
                        dispatchAction((tupledArg = [Browser_Types_Event__Event_get_Value(e_1), options], new ParameterType(2, tupledArg[0], tupledArg[1])));
                    }), parameter.Name, toList(options), inputRecord_2.Classes, parameter.Name, inputRecord_2.Disabled, inputRecord_2.HTMLProps))));
                }
                default: {
                    const isChecked = matchValue.fields[0];
                    return singleton(inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord.Disabled, parameter.Name, (_arg_2) => {
                        dispatchAction(new ParameterType(0, !isChecked));
                    }, isChecked, parameter.Name, inputRecord.HTMLProps))));
                }
            }
        }));
        return react.createElement("div", {
            className: "parameters-modal__parameter",
        }, ...children_5);
    })), (arg_7) => f2(arg_7[1])), list))), react.createElement(react.Fragment, {}, ...children_7)), inputDate((inputRecord_3 = DateOptions_get_getDefault(), (LabelText_3 = props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderTime"), new DateOptions(ofArray([EnableTimePicker(true), TimeTwentyFour(true), Value((actionState[0]).Date), FormatDateBy((date_1) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date_1)), Locale(props.Locale.FlatpickrLocale), OnChange_2((date) => {
        actionState[1]((x_4) => (new Action(x_4.Name, x_4.Description, x_4.Category, date, x_4.AddParameters, x_4.RemoveParameters)));
    })]), LabelText_3, true, inputRecord_3.Disabled, inputRecord_3.OnClearClick))))], react.createElement("div", {
        className: "parameters-modal",
    }, ...children_9)));
    return modal(true, getModalContainer(new ModalSize(1), react.createElement("div", {}, headerHtml, bodyHtml, footerHtml)));
}, "ActionModal", uncurry(2, void 0), void 0, "renderActionModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\TelecomOrder\\View.fs", 145);

function renderActions(getTranslation, actions, operationStatuses, openActionModalFn) {
    const children_35 = map((actionStatus) => {
        let children_31;
        const status = actionStatus[1];
        const action = actionStatus[0];
        const topClasses = classNames(ofArray([["action__top", true], ["action__top--with-bottom", status != null]]));
        let addButtonHtml;
        const children = [main(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Add"), defaultProps.Content, (_arg) => {
            openActionModalFn([action.Name, true]);
        }, defaultProps.Disabled, toText(printf("%s-button"))(action.Name), defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
        addButtonHtml = react.createElement("span", {
            className: "action__button",
        }, ...children);
        let removeButtonHtml;
        if (action.RemoveParameters != null) {
            const children_3 = [cancel(new ButtonProps(getTranslation("Common.Remove"), defaultProps.Content, (_arg_1) => {
                openActionModalFn([action.Name, false]);
            }, defaultProps.Disabled, toText(printf("%s-button"))(action.Name), defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
            removeButtonHtml = react.createElement("span", {
                className: "action__button",
            }, ...children_3);
        }
        else {
            removeButtonHtml = react.createElement(react.Fragment, {});
        }
        const jsonToHtml = (levelsOfNesting, json) => {
            let inputRecord;
            const bottomParameterClasses = classNames(ofArray([["bottom__parameter", levelsOfNesting <= 0], ["bottom__nested-parameter", levelsOfNesting > 0]]));
            switch (json.tag) {
                case 2: {
                    const children_11 = [inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), new CheckboxInput(true, inputRecord.LabelText, inputRecord.OnChange, json.fields[0], inputRecord.Id, inputRecord.HTMLProps)))];
                    return react.createElement("span", {
                        className: "bottom__parameter-value",
                    }, ...children_11);
                }
                case 0: {
                    const children_13 = [json.fields[0].toString()];
                    return react.createElement("span", {
                        className: "bottom__parameter-value",
                    }, ...children_13);
                }
                case 1: {
                    return react.createElement("span", {
                        className: "bottom__parameter-value",
                    }, json.fields[0]);
                }
                case 3: {
                    return react.createElement("span", {
                        className: "bottom__parameter-value",
                    }, "-");
                }
                case 4: {
                    const jsonList = json.fields[0];
                    if (isEmpty(jsonList)) {
                        return react.createElement("div", {
                            className: "bottom__parameter-value",
                        }, "-");
                    }
                    else {
                        const children_21 = map(partialApply(1, jsonToHtml, [levelsOfNesting]), jsonList);
                        return react.createElement("span", {
                            className: "bottom__parameter-array",
                        }, ...children_21);
                    }
                }
                default: {
                    const children_9 = map((tupledArg) => {
                        const children_7 = [react.createElement("span", {}, tupledArg[0]), jsonToHtml(levelsOfNesting + 1, tupledArg[1])];
                        return react.createElement("div", {
                            className: bottomParameterClasses,
                        }, ...children_7);
                    }, toList(json.fields[0]));
                    return react.createElement(react.Fragment, {}, ...children_9);
                }
            }
        };
        let bottomInfoHtml;
        if (status != null) {
            const children_25 = [jsonToHtml(0, status)];
            bottomInfoHtml = react.createElement("div", {
                className: "action__bottom",
            }, ...children_25);
        }
        else {
            bottomInfoHtml = react.createElement("div", {
                className: "action__bottom",
            });
        }
        const children_33 = [(children_31 = [react.createElement("span", {
            className: "mr-2",
        }, action.Name), react.createElement("span", {
            className: "d-flex",
        }, addButtonHtml, removeButtonHtml)], react.createElement("div", {
            className: topClasses,
        }, ...children_31)), bottomInfoHtml];
        return react.createElement("div", {
            className: "actions__action",
        }, ...children_33);
    }, map((tupledArg_1) => [tupledArg_1[1], tryFind(tupledArg_1[0], operationStatuses)], actions));
    return react.createElement(react.Fragment, {}, ...children_35);
}

export class TelecomOrderProps extends Record {
    constructor(GlobalDependencies, ContractNr, NetworkContractNumber, Number$, ReloadOrdersFn) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.NetworkContractNumber = NetworkContractNumber;
        this.Number = Number$;
        this.ReloadOrdersFn = ReloadOrdersFn;
    }
}

export function TelecomOrderProps$reflection() {
    return record_type("Containers.TelecomOrder.View.TelecomOrderProps", [], TelecomOrderProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["NetworkContractNumber", option_type(int32_type)], ["Number", option_type(string_type)], ["ReloadOrdersFn", lambda_type(unit_type, unit_type)]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reduxDispatch = useDispatch();
    const loadOperationStatusesFn = () => {
        const matchValue = props.NetworkContractNumber;
        if (matchValue != null) {
            reduxDispatch(loadOperationStatusesThunk(props.GlobalDependencies.ClientNr, matchValue, props.Number));
        }
        else {
            logwi("Cannot loadOperationStatuses, missing networkContractNr.");
        }
    };
    const errorMessageState = react.useState(void 0);
    const actionModalState = react.useState(void 0);
    const actionsState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        let matchValue_1, networkContractNr_1;
        startImmediate((matchValue_1 = props.NetworkContractNumber, (matchValue_1 == null) ? singleton_1.Return() : ((networkContractNr_1 = (matchValue_1 | 0), (actionsState[1](new LoadState$2(1)), singleton_1.Delay(() => {
            const number = defaultArg(props.Number, "-");
            return singleton_1.Bind(loadAvailableOperations_1(props.GlobalDependencies.ClientNr, networkContractNr_1, number), (_arg) => {
                const result = _arg;
                let arg_1;
                if (result.tag === 1) {
                    const msg = result.fields[0];
                    logei("[Order.LoadedAvailableOperations error]: " + msg);
                    arg_1 = (new LoadState$2(3, msg));
                }
                else {
                    arg_1 = (new LoadState$2(2, toActionMap(result.fields[0])));
                }
                actionsState[1](arg_1);
                return singleton_1.Zero();
            });
        }))))));
        loadOperationStatusesFn();
    }, [props.GlobalDependencies, props.ContractNr, props.NetworkContractNumber, props.Number]);
    react.useEffect(loadOperationStatusesFn, [props.GlobalDependencies]);
    const globalOperationStatuses = useSelector((store) => store.Telecom.OperationStatuses);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    let orderActionsHtml;
    const matchValue_3 = actionsState[0];
    switch (matchValue_3.tag) {
        case 3: {
            const msg_2 = matchValue_3.fields[0];
            if (msg_2.toLocaleLowerCase().indexOf("no baseurl set for") >= 0) {
                orderActionsHtml = react.createElement(react.Fragment, {});
            }
            else {
                const children_2 = [error(msg_2.split(""))];
                orderActionsHtml = react.createElement("div", {}, ...children_2);
            }
            break;
        }
        case 1: {
            orderActionsHtml = dotsLoading;
            break;
        }
        case 2: {
            const actions_1 = matchValue_3.fields[0];
            let actionModalHtml;
            const matchValue_4 = actionModalState[0];
            if (matchValue_4 == null) {
                actionModalHtml = react.createElement(react.Fragment, {});
            }
            else {
                const isAdd_1 = matchValue_4[1];
                const matchValue_5 = tryFind(matchValue_4[0], actions_1);
                actionModalHtml = ((matchValue_5 == null) ? react.createElement(react.Fragment, {}) : renderActionModal(new ActionModalProps(getTranslation, props.GlobalDependencies.CountryCode, locale, matchValue_5, isAdd_1, () => {
                    actionModalState[1](void 0);
                }, (tupledArg) => {
                    let matchValue_2, networkContractNr_2, resetAction, arg_4, createOrderDTO;
                    const action = tupledArg[0];
                    startImmediate((matchValue_2 = [actionsState[0], props.NetworkContractNumber], (matchValue_2[0].tag === 2) ? ((matchValue_2[1] != null) ? ((networkContractNr_2 = (matchValue_2[1] | 0), (resetAction = resetParameters(action), ((arg_4 = (new LoadState$2(2, add(resetAction.Name, resetAction, matchValue_2[0].fields[0]))), actionsState[1](arg_4)), (actionModalState[1](void 0), (createOrderDTO = getCreateOrderDTO(props.ContractNr, defaultArg(props.Number, "-"), action, tupledArg[1]), singleton_1.Delay(() => singleton_1.Bind(createOrder_1(props.GlobalDependencies.ClientNr, networkContractNr_2, action.Name, createOrderDTO), (_arg_1) => {
                        const result_1 = _arg_1;
                        return singleton_1.Combine((result_1.tag === 1) ? ((errorMessageState[1](result_1.fields[0]), singleton_1.Zero())) : ((singleton_1.Zero())), singleton_1.Delay(() => {
                            props.ReloadOrdersFn();
                            loadOperationStatusesFn();
                            return singleton_1.Zero();
                        }));
                    })))))))) : singleton_1.Return()) : singleton_1.Return()));
                })));
            }
            let actionSectionsHtml;
            const children_10 = map((categoryActions) => {
                const operationStatuses = (globalOperationStatuses.tag === 2) ? globalOperationStatuses.fields[0] : empty();
                const children_8 = [react.createElement("h3", {}, categoryActions[0]), renderActions(getTranslation, categoryActions[1], operationStatuses, (arg_6) => {
                    actionModalState[1](arg_6);
                })];
                return react.createElement("div", {}, ...children_8);
            }, List_groupBy((tupledArg_1) => tupledArg_1[1].Category, toList(actions_1), {
                Equals: (x_2, y) => (x_2 === y),
                GetHashCode: stringHash,
            }));
            actionSectionsHtml = react.createElement(react.Fragment, {}, ...children_10);
            orderActionsHtml = react.createElement("div", {
                className: "order__actions",
            }, actionSectionsHtml, actionModalHtml);
            break;
        }
        default: {
            orderActionsHtml = react.createElement(react.Fragment, {});
        }
    }
    let errorMessageHtml;
    const matchValue_6 = errorMessageState[0];
    if (matchValue_6 == null) {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    else {
        const msg_3 = matchValue_6;
        const children_13 = [error(msg_3.split(""))];
        errorMessageHtml = react.createElement("div", {}, ...children_13);
    }
    return react.createElement("div", {
        className: "order mt-3",
        ["data-regression"]: "telecom-order-container",
    }, errorMessageHtml, orderActionsHtml);
}, "TelecomOrder", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\TelecomOrder\\View.fs", 392);

